"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Viewport = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("./context");
const useSyncStore_1 = require("../../hooks/useSyncStore");
const wrapClass = (0, nano_theme_1.rule)({
    fl: '1',
    pos: 'relative',
    ov: 'hidden',
});
const viewportClass = (0, nano_theme_1.rule)({
    w: '100%',
    h: '100%',
    bxz: 'border-box',
    ovy: 'scroll',
    scrollbarWidth: 'none',
    MsOverflowStyle: 'none',
    // Stop scroll chaining at the viewport. Without this, scrolling past the
    // bottom (or top) of an inner ScrollArea propagates to whichever ancestor
    // is scrollable next — and that ancestor doesn't have our scrollbar-hiding
    // CSS, so macOS flashes its native overlay scrollbar on the parent during
    // the rubber-band. `contain` also disables the page-level rubber-band.
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': {
        d: 'none',
    },
});
const contentClass = (0, nano_theme_1.rule)({
    minW: '100%',
    minH: '100%',
    d: 'flex',
});
const addCssLength = (base, inset) => {
    if (inset === undefined)
        return base || undefined;
    if (typeof inset === 'number')
        return base + inset;
    if (!base)
        return inset;
    return `calc(${base}px + ${inset})`;
};
const Viewport = ({ children, className, style, ...rest }) => {
    const state = (0, context_1.useScrollArea)();
    const headerHeight = (0, useSyncStore_1.useSyncStore)(state.headerHeight$);
    const footerHeight = (0, useSyncStore_1.useSyncStore)(state.footerHeight$);
    const { paddingTop, paddingBottom, ...restStyle } = style ?? {};
    return (React.createElement("div", { className: wrapClass },
        React.createElement("div", { ...rest, ref: state.setViewport, className: viewportClass + (className ? ' ' + className : ''), style: {
                paddingTop: addCssLength(headerHeight, paddingTop),
                paddingBottom: addCssLength(footerHeight, paddingBottom),
                ...restStyle,
            } },
            React.createElement("div", { className: contentClass }, children))));
};
exports.Viewport = Viewport;
